import {
  toggleSidebarShown,
} from '../actions/sidebar-settings.actions';
import { SidebarSettingsModel } from 'app/models/sidebar-settings.model';
import { createReducer, on, Action } from '@ngrx/store';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';

export interface State {
  sidebarSettings: SidebarSettingsModel;
}

export const initialState: State = {
  sidebarSettings: new SidebarSettingsModel(true),
};

const featureReducer = createReducer(
  initialState,
  on(toggleSidebarShown, (state) => {
    const sidebarSettingsToToggle = {
      ...state.sidebarSettings,
    };

    sidebarSettingsToToggle.isHidden = !sidebarSettingsToToggle.isHidden;

    return {
      ...state,
      sidebarSettings: sidebarSettingsToToggle,
    };
  }),
  on(setActiveCompany, (state) => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
